export default {"src":"/_next/static/media/13.8bff0ce2.svg","height":25,"width":48};